const options = {
  dataZoom: [
    {
      type: 'inside', //图表下方的伸缩条
      startValue: 0,
      endValue: 6,
      zoomLock: true,
      preventDefaultMouseMove: false //禁止canvas上下滑动
    }
  ],
  grid: {
    top: '20%',
    bottom: '20%',
    left: '5%',
    right: '5%'
  },
  xAxis: {
    type: 'category',
    boundaryGap: false,
    splitLine: {
      show: true,
      lineStyle: {
        color: 'rgba(0,0,0,0.1)'
      }
    },
    axisLabel: {
      show: true,
      color: 'rgba(0,0,0,0.5)', //更改坐标轴文字颜色
      fontSize: 10 //更改坐标轴文字大小
    },
    axisLine: {
      show: true,
      lineStyle: {
        color: '#ccc'
      }
    },
    data: []
  },
  yAxis: {
    show: false,
    type: 'value',
    splitLine: {
      show: true,
      lineStyle: {
        color: 'rgba(0,0,0,0.1)'
      }
    },
    min: function (value) {
      return value.min - ((value.max - value.min) / 0.5) * 0.3
    },
    max: function (value) {
      return value.max + ((value.max - value.min) / 0.5) * 0.2
    }
  },
  series: [
    {
      data: [],
      type: 'line',
      symbol: 'circle',
      symbolSize: 8,
      /*  smooth: true, */
      lineStyle: {
        color: '#6236FF' //曲线的颜色
      },
      itemStyle: {
        color: '#6236FF', //点的颜色
        borderWidth: 3
      },
      label: {
        show: true,
        color: '#6236FF',
        position: 'top',
        fontSize: 10
      }
      /* areaStyle: {
                color: {
                    type: "linear",
                    x: 0,
                    y: 0,
                    x2: 0,
                    y2: 1,
                    colorStops: [
                        {
                            offset: 0,
                            color: "rgba(240,70,70,0.7)", // 0% 处的颜色
                        },
                        {
                            offset: 1,
                            color: "rgba(240,70,70,0)", // 区域100% 处的颜色
                        },
                    ],
                    global: false, // 缺省为 false
                },
            }, */
    }
  ]
}
export { options }
